module.exports = __webpack_public_path__ + "c7f9798aad9bd8db1900bcb61e5d3ec2.png";